<div class="grid text-center">
    <div>
        <p>
            Nexus Management Services Pte Ltd<br />
            2 Venture Drive, #08-02 Vision Exchange Singapore 608526<br />
            Office Tel: +65 69147715 | Email: hr&#64;nexus-ms.com.sg
        </p>
    </div>
</div>
